<template>
  <div class="form-group mb-3">
    <label v-if="label" :for="id">{{ label }}</label>
    <div class="input-group" v-if="prefix">
      <div class="input-group-append">
        <div class="input-group-text">
          <span :class="class"></span>
        </div>
      </div>
      <input :id="id" :type="type" :value="modelValue" v-bind="{ ...$attrs, class: null }"
        @input="$emit('update:modelValue', $event.target.value)" class="form-control" />
    </div>
    <div class="input-group" v-else>
      <input :id="id" :type="type" :value="modelValue" v-bind="{ ...$attrs, class: null }"
        @input="$emit('update:modelValue', $event.target.value)" class="form-control" />
      <div class="input-group-append">
        <div class="input-group-text">
          <span :class="class"></span>
        </div>
      </div>
    </div>
    <div v-if="error" style="color: #dc3545; font-size: 80%;">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  name: 'input-sufix',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `input-group-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    prefix: {
      type: Boolean,
      default: false,
    },
    modelValue: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
